// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5e11096a","977":"99dd51af"}[chunkId] + ".chunk.js";
};